/* @jsxImportSource react */

import * as React from 'react';
import { type VariantProps } from 'class-variance-authority';
import { flagVariants } from './Flag.variants';

export interface FlagProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof flagVariants> {
  /** text displayed in flag */
  text: string;
}

/**
 * Flag component is used to display a small piece of information in a colored box
 * */
const Flag = ({ text, variant = 'neutral', size = 'default', className, ...rest }: FlagProps) => (
  <div className={flagVariants({ variant, size, className })} {...rest}>
    {text}
  </div>
);

Flag.displayName = 'Flag';

export { Flag };
